<template>
  <div id="app">
    <div v-if="isAppLoading" class="app-loading fixed-top">
      <img class="utku" src="static/logo@2x.png" width="372" height="96" />
      <img class="lenoi" src="static/logo@2x_old.png" width="372" height="96" />
      <img class="loadingSpinner" src="static/loading.svg" width="128" height="128" />
    </div>
    <template v-else>
      <leftbar v-if="leftBar" :activeMenuIndex="activeMenuIndex" />
      <toolbar v-if="toolBar" :title="title" :titleEng="titleEng"/>
      <div class="rv-wrapper">
        <router-view />
        <!--
        <div class="row">
          <div class="col-md-12">
            <div :class="{'marginity' : marginity}">
              <router-view />
            </div>
          </div>
        </div>
        -->
      </div>
    </template>
  </div>
</template>

<script>
/* eslint-disable */
import LeftBar from '@/components/LeftBar'
import TopBar from '@/components/Topbar'
import ToolBar from '@/components/ToolBar'
import LoadingSpinner from '@/partials/LoadingSpinner'

export default {
  name: 'App',
  computed : {
    isAppLoading: function() { return this.$store.getters.isAppLoading; }
  },
  data () {
    return {
      marginity: false,
      leftBar: false,
      toolBar: false,
      title: '',
      titleEng: '',
      activeMenuIndex: 0
    }
  },
  components: {
    'leftbar': LeftBar,
    'topbar' : TopBar,
    'toolbar' : ToolBar,
    'LoadingSpinner': LoadingSpinner,
  },
  methods: {
    IOModules() {
      if(this.$router.history.current["path"].indexOf('login') > -1 ||
        this.$router.history.current["path"].indexOf('logout') > -1) 
      {
        this.leftBar = false
        this.toolBar = false
        this.marginity = false
      } else {
        this.leftBar = true
        this.toolBar = true
        this.marginity = true
      }

      let urlPath = this.$router.history.current["path"];
      if(urlPath.indexOf('/stok') > -1) {
        this.title = "STOK YÖNETİMİ";
        this.titleEng = "STOCK MANAGEMENT";
        this.activeMenuIndex = 1
      }
      else if(urlPath.indexOf('/stok/seri-numaralar') > -1) {
        this.title = "SERİ NUMARALAR";
        this.titleEng = "SERIAL NUMBERS";
      }
      else if(urlPath.indexOf("/ariza-kayitlari") > -1) {
        this.title = "ARIZA KAYITLARI";
        this.titleEng = "MAINTENANCE TRACKING ";
        this.activeMenuIndex = 3
      }
      else if(urlPath.indexOf("/ariza-kaydi-ekle") > -1) {
        this.title = "ARIZA KAYDI EKLE";
        this.titleEng = "CREATE MAINTENANCE RECORD";
        this.activeMenuIndex = 3
      }
      else if(urlPath.indexOf('/urun-cikislari') > -1) {
        this.title = "ÜRÜN ÇIKIŞLARI";
        this.titleEng = "SELLINGS";
        this.activeMenuIndex = 5
      }
      else if(urlPath.indexOf('/notlar') > -1) {
        this.title = "NOTLAR";
        this.titleEng = "NOTES";
          this.activeMenuIndex = 7
      }
      else if(urlPath.indexOf('/saha-operasyon') > -1) {
        this.title = "SAHA - OPERASYON KAYITLARI"
        this.titleEng = "FIELD OPERATION TRACKING";
        this.activeMenuIndex = 4
      }
      else if(urlPath.indexOf('/uretimler') > -1) {
        this.title = "ÜRETİMLER";
        this.titleEng = "PRODUCTION";
        this.activeMenuIndex = 2
      }
      else if(urlPath.indexOf('/uretim/urunler') > -1) {
        this.title = "ÜRÜNLER";
        this.titleEng = "PRODUCTS";
        this.activeMenuIndex = 2
      }
      else if(urlPath.indexOf('/sarf-malzemeleri') > -1) {
        this.title = "SARF MALZEMELERİ";
        this.titleEng = "EQUIPMENTS";
        this.activeMenuIndex = 6
      }
      else if(urlPath.indexOf('/debug') > -1) {
        this.title = "TEST EKRANI";
        this.titleEng = "DIAGNOSTICS";
        this.activeMenuIndex = 8
      }
      else if(urlPath.indexOf('/uretim/setler') > -1) {
        this.title = "ÜRÜN SETLERİ";
        this.titleEng = "SETS";
        this.activeMenuIndex = 2
      }
      else if(urlPath.indexOf('/hatlar') > -1) {
        this.title = "HATLAR";
        this.titleEng = "SIM CARDS";
        this.activeMenuIndex = 9
      }
      else if(urlPath.indexOf('/montaj-noktalari') > -1) {
        this.title = "MONTAJ NOKTALARI";
        this.titleEng = "OPERATION POINTS";
        this.activeMenuIndex = 4
      }
      else if(urlPath.indexOf('/bayii-aidat-takibi') > -1) {
        this.title = "BAYİİ AİDAT TAKİBİ";
        this.titleEng = "RETAILER SUBSCRIPTIONS";
        this.activeMenuIndex = 10
      } 
      else if(urlPath.indexOf('/personel') > -1) {
        this.title = "PDKS RAPORU"
        this.titleEng = "EMPLOYEE TIMING REPORTS"
        this.activeMenuIndex = 11
      }
      else if(urlPath.indexOf('/servis-randevulari') > -1) {
        this.title = "SERVİS RANDEVULARI"
        this.titleEng = "APPOINTMENTS"
        this.activeMenuIndex = 4
      }
      else if(urlPath.indexOf('/teklifler') > -1) {
        this.title = "TEKLİF TALEPLERİ"
        this.titleEng = "BID REQUESTS"
        this.activeMenuIndex = 12
      }
      else if(urlPath.indexOf('/aranma-talepleri') > -1) {
        this.title = "ARANMA TALEPLERİ"
        this.titleEng = "CALL REQUESTS"
        this.activeMenuIndex = 13
      }
      else if(urlPath.indexOf('/uetds/araclar') > -1) {
        this.title = "UETDS ENTEGRASYONU"
        this.titleEng = "UETDS INTEGRATION"
        this.activeMenuIndex = 21
      }
      else if(urlPath.indexOf('/kargo-takip') > -1) {
        this.title = "KARGO TAKİBİ"
        this.titleEng = "SHIPMENT TRACKING"
        this.activeMenuIndex = 22
      }
      else if(urlPath.indexOf('/fiyat-listesi') > -1) {
        this.title = "FİYAT LİSTESİ"
        this.titleEng = "PRICE LIST"
        this.activeMenuIndex = 23
      }
      else if(urlPath.indexOf('/luca-kodlari') > -1) {
        this.title = "LUCA KODLARI"
        this.titleEng = "LUCA CODES"
        this.activeMenuIndex = 24
      }
      else if(urlPath.indexOf('/fatura-yuklemeleri') > -1) {
        this.title = "FATURA YÜKLEMELERİ"
        this.titleEng = "INVOICE UPLOADS"
        this.activeMenuIndex = 25
      }
      else if(urlPath.indexOf('/fatura-yildizlari') > -1) {
        this.title = "FATURA YILDIZLARI"
        this.titleEng = "INVOICE STARS"
        this.activeMenuIndex = 26
      }
      else if(urlPath.indexOf('/kesik-cihazlar') > -1) {
        this.title = "ÇEVRİMDIŞI CİHAZLAR"
        this.titleEng = "DISCONNECTED DEVICES"
        this.activeMenuIndex = 27
      }
      else if(urlPath.indexOf('/demo-talepleri') > -1) {
        this.title = "DEMO TALEPLERİ"
        this.titleEng = "DEMO REQUESTS"
        this.activeMenuIndex = 28
      }
      else {
        this.title = "GÖSTERGELER"
        this.titleEng = "DASHBOARD";
        this.activeMenuIndex = 0
      }
    }
  },
  created() {
    this.IOModules()
  },
  watch: {
    $route: function() { 
      this.IOModules()
    }
  },
}
</script>

<style>
* {
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, 'Fira Sans', "Segoe UI",Helvetica,Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #24292e;
}

body {
  background-color: #FFF;
  padding-top: 80px;
  padding-left: 60px;

}

label {
  font-size: 14px;
  font-weight: 600;
  display: block;
  margin-bottom: 7px;
}

.rv-wrapper { width: 100%; height: 100%; }

.marginity {
  padding-top: 80px;
  padding-left: 60px;
}

.v-application ul {
  padding-left: 0px !important;
}

.loadingSpinner {
  position: absolute;
  left: 50%;
  top: 45%;
  margin-left: -64px;
}

</style>



// WEBPACK FOOTER //
// src/App2.vue